// removed by extract-text-webpack-plugin
module.exports = {"music":"_12hS","c":"nEiL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/music/index.less
// module id = 258
// module chunks = 0